import styled from 'styled-components'

export const Container = styled.section`
  padding-top: 120px;
  .token-content{
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 48px;
    justify-content: center;
  }
  @media screen and (max-width: 1279px){
    .token-content{
      flex-wrap: wrap;
    }
  }
`
